import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import accounting from 'accounting';
import PercentageWizardTable from "./percentageWizardTable";
import '../../../style/premiumSettingsWizard.css';
import Dots from 'react-activity/lib/Dots';
import FormResponseMessage from "../../formResponseMessage";
import { CANADA_COUNTRY, COUNTRY, CURRENCY, PERCENAGE_SYMBOL } from '../../../helpers/variables';
import { FormGroup } from 'arag-ui-lib';
import { formatedMoney } from '../../../helpers/functions';
import WordingExtraIdentifiers from './wordingExtraIdentifiers';

const PercentageStep6 = (props) => {
    if(props.currentStep !== 6)
        return null;  
       
    const history = useHistory();

    useEffect(() => {
        if (!props.isApplicationPremium && props.successMsg !== '') {
            history.push({
                pathname: '/premium-settings',
                state: 
                { 
                    successMsg: props.successMsg ,
                    isRedirection: true 
                }
            });
        }
    }, [props.successMsg, history]);

    return (       
        <div>          
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>                  
            {!props.isApplicationPremium && (
                <FormGroup
                    labelSize="col-sm-3"
                    inputSize="col-sm-6"
                    label="Valid from"
                    variant="plain"
                    inputProps={{ label: props.validFrom && new Date(props.validFrom).toLocaleDateString('en-GB') +
                        (props.validUntil ? (' - ' + new Date(props.validUntil).toLocaleDateString('en-GB')) : '') }}
                />
            )}
            <FormGroup
                labelSize="col-sm-3"
                inputSize="col-sm-6"
                label="Limit Of Indemnity"
                variant="plain"
                inputProps={{ label: formatedMoney(props.limitOfIndemnity, CURRENCY) }}
            />            
            <FormGroup
                labelSize="col-sm-3"
                inputSize="col-sm-6"
                label="Notes"
                variant="textarea"
                inputProps={{
                    value: props.notes,
                    disabled: true,
                    rows: 2
                }}
            />
            <FormGroup
                labelSize="col-sm-3"
                inputSize="col-sm-6"
                label="Comments"
                variant="textarea"
                inputProps={{
                    value: props.comments,
                    disabled: true,
                    rows: 2
                }}
            />
            {COUNTRY == CANADA_COUNTRY ?
                <WordingExtraIdentifiers 
                    displayedCoverageType = {props.displayedCoverageType}
                    displayedDeductible = {props.displayedDeductible}
                    displayedEndorsement = {props.displayedEndorsement}
                />
            :
                <FormGroup
                    labelSize="col-sm-3"
                    inputSize="col-sm-6"
                    label="Endorsements"
                    variant="textarea"
                    inputProps={{
                        value: props.endorsements,
                        disabled:true
                    }}
                />
            }
            <div className="row">
                <div className="col-sm-12">
                    <hr className="appFormRefSettings-hr"/>
                </div>
            </div>
            <FormGroup
                labelSize="col-sm-3"
                inputSize="col-sm-6"
                label="Recoverable Rate"
                variant="plain"
                inputProps={{ label: `${formatedMoney(props.recoverableRatePercentage, '')} ${PERCENAGE_SYMBOL}` }}
            />
            <PercentageWizardTable
                isEditMode={props.isEditMode}
                solicitorListLength={props.solicitorListLength}
                showTable={props.showTable} //if true that means the hoc is rendered through the premium settings component
                selectedCaseType={props.selectedCaseType}
                selectedSubCaseType={props.selectedSubCaseType}
                getSolicitor={props.getSolicitor}
                isPlain={true}
                tableData={props.tableData}
                getDamageBands= {props.getDamageBands}
                damageBands={props.damageBands}
                selectedCaseStages={props.selectedCaseStages}
                getSelectedCaseStages={props.getSelectedCaseStages}
                solicitorsList={props.solicitorsList}
                getTableHeaderData={props.getTableHeaderData}
            />
            {
                props.posting || props.patching || props.appPremiumSettingsIndicator?
                    <div className="form-group">
                        <div className="col-sm-6 col-sm-offset-3">
                            <div className="col-sm-5"></div>
                            <Dots/>
                        </div>
                    </div>
                    :
                    null
            }
            {
                props.badResponseMsg !== '' ?
                    <FormResponseMessage
                        LeftWrapper=""
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-reject"
                        Message={props.badResponseMsg}
                    />
                    :
                    null
            }
           
        </div>
    )
};

export default PercentageStep6;
